import TotalCase from "../../../images/totalCase.svg";
import KgEntered from "../../../images/material_kg.svg";
import TotalOrangeCase from "../../../images/total_orange.svg";
import MaterialOrange from "../../../images/material_orange.svg";
import TotalEmployee from "../../../images/total_emp.svg";
import EmployeeUnloading from "../../../images/emp_unloading.svg";
import EmployeeWashing from "../../../images/emp_washing.svg";
import AbsentEmployee from "../../../images/emp_absent.svg";
import { useMemo, useState } from "react";
import {
  useGetAllWorkingAreasQuery,
  useGetAttendanceOverviewQuery,
  useGetReceivingEmployeeSummaryQuery,
  useGetSummaryQuery,
} from "../../../app/globalApi";
import AddEmployeeModal from "../../../components/shared/modalContent/AddEmployeeModal";
import { PlusSvg } from "../../../svgFiles/PlusSvg";
import Button from "../../../components/shared/buttons/button";
import GridCard from "../../../components/shared/gridCard/GridCard";
import DateSelector from "../../../components/shared/fields/DateSelector";
import { ReceivingCharts } from "./ReceivingCharts";
import { EditSvg } from "../../../svgFiles/EditSvg";
import { skipToken } from "@reduxjs/toolkit/query";
import GridCardNew from "../../../components/shared/gridCard/GridCardNew";
import useTranslator from "../../../hooks/useTranslator";
import { formatDateAndTime, getCurrentDate } from "../../../helpers/Utils";
import { PROJECT_DATE_FORMAT } from "../../../helpers/constants";

const ReceivingDashboard = () => {
  const { _t } = useTranslator();  
  const currentDate = getCurrentDate("YYYY-MM-DD");
  const [date, setDate] = useState(currentDate);
  const [tab, setTab] = useState("dashboard");

  const { data: summaryData } = useGetSummaryQuery({ tab, date });
  const { data: employeeSummaryData } = useGetReceivingEmployeeSummaryQuery({
    date: date,
  });
  const { data: workingAreasData, isLoading: isWorkingAreasLoading } =
    useGetAllWorkingAreasQuery();

  const receivingAreaId = useMemo(() => {
    if (!workingAreasData?.data) return null;
    const receivingArea = workingAreasData.data.find(
      (area) => area.name === "Receiving Area"
    );
    return receivingArea ? receivingArea.id : null;
  }, [workingAreasData]);

  const {
    data: attendanceOverviewData,
    isLoading: isAttendanceLoading,
    isError: isAttendanceError,
  } = useGetAttendanceOverviewQuery(
    receivingAreaId
      ? { working_area_id: receivingAreaId, date: date }
      : skipToken
  );

  const listItems = [
    {
      label: _t("total_cases_entered", "Total Cases Entered"),
      value: summaryData?.data.total_cases_entered,
      icon: TotalCase,
    },
    {
      label: _t("material_entered_kg", "Material Entered in KG"),
      value: summaryData?.data.material_entered_kg,
      icon: KgEntered,
    },
    {
      label: _t("total_orange_cases", "Total Orange Cases"),
      value: summaryData?.data.total_orange_cases,
      icon: TotalOrangeCase,
    },
    {
      label: _t("weight_in_orange", "Weight in Orange Cases"),
      value: summaryData?.data.weight_in_orange_cases,
      icon: MaterialOrange,
    },
  ];
  // const employeelistItems = [
  //   {
  //     label: "Total Employees",
  //     value: employeeSummaryData?.data.emp_total,
  //     icon: TotalEmployee,
  //   },
  //   {
  //     label: "Employees in Unloading Area",
  //     value: employeeSummaryData?.data.emp_in_unloading,
  //     icon: EmployeeUnloading,
  //   },
  //   {
  //     label: "Employee in Washing Area",
  //     value: employeeSummaryData?.data.emp_in_washing,
  //     icon: EmployeeWashing,
  //   },
  //   {
  //     label: "Absent Employees",
  //     value: employeeSummaryData?.data.emp_absent,
  //     icon: AbsentEmployee,
  //   },
  // ];

  const attendanceListItems = useMemo(() => {
    if (!attendanceOverviewData?.data) return [];

    const items = [
      {
        label: _t("total_employees", "Total Employees"),
        value: attendanceOverviewData.data.total_employees,
        icon: TotalEmployee,
      },
    ];

    for (const [role, count] of Object.entries(
      attendanceOverviewData.data.roles
    )) {
      items.push({
        label: role.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()), // format label
        value: count,
        icon: EmployeeWashing,
      });
    }

    return items;
  }, [attendanceOverviewData]);

  return (
    <div>

      <div className="overview cmn_card mb-3">
        <div className="overview_header d-flex gap-2 align-items-center">
          <h6 className="mb-0 flex-grow-1">{_t("overview", "Overview")}</h6>
          <DateSelector setDate={setDate} />
        </div>
        <ul className="m-0 grid_card_wrapper">
          {listItems.map((list, index) => (
            <GridCard
              key={index}
              title={list.label}
              value={list.value}
              icon={list.icon}
              day={currentDate === date ? _t("today", "Today") : formatDateAndTime(date ,PROJECT_DATE_FORMAT)}
            />
          ))}
        </ul>
      </div>
      <ReceivingCharts />
      <div className="overview cmn_card">
        <div className="overview_header d-flex gap-2 align-items-center">
          <h6 className="mb-0 flex-grow-1">{_t("today_employee_log", "Today Employees Log")}
          </h6>
          {/* {employeeSummaryData?.data.emp_total > 0 ? (
            <Button
              onClick={AddEmployee}
              icon={<EditSvg color="#fff" />}
              label="Edit Employees Data"
              size="small"
            />
          ) : (
            <Button
              onClick={AddEmployee}
              icon={PlusSvg}
              label="Add Employees Data"
              size="small"
            />
          )} */}
        </div>
        <ul className="m-0 grid_card_wrapper employee_list_grid">
          {isAttendanceLoading ? (
            <p>{_t("loading_attendance", "Loading attendance data...")}</p>
          ) : isAttendanceError ? (
            <p>{_t("error_attendance", "Error loading attendance data.")}</p>
          ) : (
            <>
              {attendanceListItems.map((list, index) => (
                <>
                  <GridCardNew
                    key={index}
                    title={list.label}
                    value={list.value}
                    icon={list.icon}
                    day={currentDate === date ? _t("today", "Today") : formatDateAndTime(date,PROJECT_DATE_FORMAT)}
                  />
                </>
              ))}
            </>
          )}
        </ul>
      </div>
    </div>
  );
};

export default ReceivingDashboard;
